var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 19.1673L20.8333 16.2507L22 15.084L23.75 16.834L27.25 13.334L28.4166 14.5007L23.75 19.1673ZM19.1666 15.834H11.6666V17.5007H19.1666V15.834ZM27.5 21.1673L26.3333 20.0007L24.1666 22.1673L22 20.0007L20.8333 21.1673L23 23.334L20.8333 25.5007L22 26.6673L24.1666 24.5006L26.3333 26.6673L27.5 25.5007L25.3333 23.334L27.5 21.1673ZM19.1666 22.5007H11.6666V24.1673H19.1666V22.5007Z",
    fill: "#8D8885"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEdit);
export default __webpack_public_path__ + "static/media/illustration-edit.e5ce4a6e71e5e10f42c68ab839069063.svg";
export { ForwardRef as ReactComponent };